module.exports = __webpack_public_path__ + "static/media/116n.f25ec783.svg";